import { IRoute } from "src/pages/Router/routes";
import { Icons } from "src/library/components/Icon/types";
import { canViewByRoleCodes } from "src/core/shared/utils/canViewByRoleCodes";

import { AdminMain } from "..";
import AccountingPage from "./AccountingPage";
import InvoiceDetailsPage from "./InvoiceDetailsPage";
import InvoiceCheckoutPage from "./InvoiceCheckoutPage";
import TransactionDetailsPage from "./TransactionDetailsPage";

const AdminAccounting: IRoute[] = [
  {
    exact: true,
    path: "/admin/accounting",
    canView: store => canViewByRoleCodes(store, [ "account-manager" ], "DENY"),
    pageComponent: AccountingPage,
    title: "Accounting",
    icon: Icons.CURRENCYPOUND,
    menuType: "ADMIN_ACCOUNTING",
    privateRoute: true,
    parent: AdminMain[ 0 ],
    modules: [ "accounting" ],
    permissions: [ "view-transaction" ],
    roles: [ "admin" ]
  }
];

const NestedRoutes: IRoute[] = [

  {
    exact: true,
    path: "/admin/accounting/invoices/:invoiceId",
    pageComponent: InvoiceDetailsPage,
    title: "Invoice Details",
    menuType: "EMPTY",
    privateRoute: true,
    parent: AdminAccounting[ 0 ],
    modules: [ "accounting" ],
    permissions: [ "view-transaction" ],
    roles: [ "admin" ]
  },
  {
    exact: true,
    path: "/admin/accounting/invoices/:invoiceId/checkout",
    pageComponent: InvoiceCheckoutPage,
    title: "Invoice Checkout",
    menuType: "EMPTY",
    privateRoute: true,
    parent: AdminAccounting[ 0 ],
    modules: [ "accounting", "payment" ],
    permissions: [ "view-transaction" ],
    roles: [ "admin", "customer" ]
  },
  {
    exact: true,
    path: "/admin/accounting/transactions/:transactionId",
    pageComponent: TransactionDetailsPage,
    title: "Transaction Details",
    menuType: "EMPTY",
    privateRoute: true,
    parent: AdminAccounting[ 0 ],
    modules: [ "accounting" ],
    permissions: [ "view-transaction" ],
    roles: [ "admin" ]
  }
];

export default [ ...AdminAccounting, ...NestedRoutes ];
